<template>
    <div class="pageBox">
       <img src="../../assets/img/area.png"/> 测试
    </div>
</template>
<style lang="scss" scoped>
.pageBox{
    width: 100%;
    height: 100vh;    
    background-color: rgb(40, 172, 225);
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
